<template>
  <v-container class="py-10 px-0 order-view-details">
    <v-sheet class="mx-auto position-relative" max-width="600px">
      <v-btn
        class="print-btn order-view-details-copy"
        color="#eeeeee"
        @click="copy()"
        depressed
        x-small
        fab
      >
        <v-icon color="#444" size="18"> fa-copy </v-icon>
      </v-btn>

      <TableWidget
        class="mb-6"
        :headers="headerTable.headers"
        :items="headerTable.items"
        hide-default-header
        hide-default-footer
      />
      <TableWidget
        v-if="pricedProductsTable && pricedProductsTable.items.length"
        class="mb-6"
        :headers="pricedProductsTable.headers"
        :items="pricedProductsTable.items"
        hide-default-footer
      />
      <TableWidget
        v-if="footerTable"
        class="mb-6"
        :headers="footerTable.headers"
        :items="footerTable.items"
        hide-default-header
        hide-default-footer
      />
      <TableWidget
        v-if="noPricedProductsTable && noPricedProductsTable.items.length"
        class="mb-6"
        :headers="noPricedProductsTable.headers"
        :items="noPricedProductsTable.items"
        hide-default-footer
      />

      <v-btn class="print-btn" @click="print" color="primary" block depressed>
        IMPRIMIR
      </v-btn>
    </v-sheet>
  </v-container>
</template>

<script>
import TableWidget from "../components/widgets/TableWidget.vue";
import { formatPrice } from "../utils/formatPrice";

export default {
  computed: {
    headerTable() {
      return {
        headers: [
          {
            align: "center",
            value: "text",
          },
        ],
        items: [
          {
            text: this.informations.name?.toUpperCase(),
          },
        ],
      };
    },
    pricedProductsTable() {
      if (!this.order.products) return null;

      return {
        headers: [
          { text: "DESC.", value: "title", align: "left" },
          { text: "VAR.", value: "variant", align: "left" },
          { text: "QTDE", value: "quant", align: "left" },
          { text: "VAL", value: "price", align: "left" },
          { text: "TOTAL", value: "total", align: "right" },
        ],
        items: this.order.products
          .filter(({ price }) => price)
          .map((product) => {
            product.total = this.formatPrice(product.price * product.quant);

            if (product.variant && product.variant.title)
              product.variant = product.variant.title;

            return product;
          }),
      };
    },
    noPricedProductsTable() {
      if (!this.order.products) return null;

      return {
        headers: [
          { text: "DESC.", value: "title", align: "left" },
          { text: "VAR.", value: "variant", align: "left" },
          { text: "QTDE", value: "quant", align: "left" },
          { text: "VAL", value: "val", align: "right" },
        ],
        items: this.order.products
          .filter(({ price }) => !price)
          .map((product) => {
            product.val = "Sob Consulta";

            if (product.variant && product.variant.title)
              product.variant = product.variant.title;

            return product;
          }),
      };
    },
    footerTable() {
      const totalPrice =
        this.pricedProductsTable && this.pricedProductsTable.items
          ? this.pricedProductsTable.items.reduce(
              (r, { quant, price }) => r + price * quant,
              0
            )
          : null;

      if (!totalPrice) return false;

      const item = {
        headers: [
          { value: "title", align: "left" },
          { value: "value", align: "right" },
        ],
        items: [],
      };

      if (this.order.deliveryFee)
        item.items.push({
          title: "TAXA DE ENTREGA",
          value: this.formatPrice(this.order.deliveryFee),
        });

      item.items.push({
        title: "TOTAL VALOR",
        value: this.formatPrice(totalPrice),
      });

      return item;
    },
    uuid() {
      return this.$route.params["uuid"];
    },
    informations() {
      return this.$rest("informations").item;
    },
    order() {
      return this.$rest("orders").item;
    },
  },
  methods: {
    formatPrice,
    print() {
      window.print();
    },
    fill(count, caractere) {
      if (count <= 0) {
        return " ";
      }

      return caractere.repeat(count);
    },
    copy() {
      const fill = this.fill;
      const formatPrice = this.formatPrice;

      const text = [
        "Olá, gostaria de fazer o seguinte pedido:\n",
        "",
        "```________________________________",
      ];

      this.pricedProductsTable.items.forEach(function (
        { id, title, observations, quant, price, variant },
        index
      ) {
        if (index > 0) text.push("");

        let spaces = fill(31 - `#${id}${title}`.length, " ");
        text.push(`#${id}${spaces}${title}`);

        if (variant) {
          let dots = fill(31 - `VARIAÇÃO${variant}`.length, ".");
          text.push(`VARIAÇÃO${dots}${variant}`);
        }

        let formatedPrice = "R$ " + formatPrice(price * quant);
        let dots = fill(31 - `${quant} UN${formatedPrice}`.length, ".");
        text.push(`${quant} UN${dots}${formatedPrice}`);

        if (observations) text.push(`Obs.: ${observations}`);
      });

      if (this.order.deliveryFee) {
        let feeFormated = formatPrice(this.order.deliveryFee);
        let dots = fill(31 - `Taxa de entrega${feeFormated}`.length, ".");
        text.push("");
        text.push(`Taxa de entrega${dots}${feeFormated}`);
      }

      const totalPrice =
        this.pricedProductsTable && this.pricedProductsTable.items
          ? this.pricedProductsTable.items.reduce(
              (r, { quant, price }) => r + price * quant,
              0
            )
          : null;

      if (totalPrice) {
        let formatedTotalPrice = formatPrice(totalPrice);
        let dots = fill(31 - `TOTALR$ ${formatedTotalPrice}`.length, ".");
        text.push("________________________________");
        text.push(`TOTAL${dots}R$ ${formatedTotalPrice}`);
        text.push("");
      }

      text.push("```");
      // text.push(this.files + "/o/" + this.uuid);

      navigator.clipboard.writeText(text.join("\n"));

      alert("Pedido copiado");
    },
  },
  created() {
    this.$rest("orders")
      .get({ id: this.uuid })
      .catch(() => this.$router.replace("/erro404"));
  },
  components: {
    TableWidget,
  },
};
</script>

<style lang="scss" scoped>
.order-view-details-copy {
  position: absolute;
  right: 5px;
  top: -5px;
}
</style>

<style>
@media print {
  html,
  body {
    max-width: 300px !important;
    width: 300px !important;
    font-size: 12px !important;
    height: auto !important;
    overflow: hidden !important;
  }

  .v-main,
  .v-application--wrap {
    padding: 0 !important;
    min-height: min-content !important;
    flex: none;
  }

  .v-app-bar,
  .footer-shell,
  .shopping-cart-widget,
  .print-btn,
  .whatsapp-button {
    display: none !important;
  }

  .order-view-details {
    padding: 0px !important;
  }
}
</style>
